module.exports = __webpack_public_path__ + "static/media/Debt.bfda916b.png";